export default {
  unreadNotifications(state) {
    return state.notifications.reduce((acc, element) => {
      return element.read ? acc : acc + 1;
    }, 0);
  },
};
